const FIRST_PARTY_API_HOSTS = new Set<string>([
  'app.lionshare.co',
  'demo.lionshare.co',
  // The Place demo: the place-survey Worker hands every non-survey path on to app.lionshare.co.
  'place.lionshare.co',
  'lionshare-convex-web.vercel.app',
]);

interface ApiBaseUrlContext {
  configuredApiUrl?: string;
  hostname?: string;
  pathname?: string;
}

export function resolveApiBaseUrl(context: ApiBaseUrlContext): string {
  const configuredApiUrl = context.configuredApiUrl?.trim();

  if (context.hostname && FIRST_PARTY_API_HOSTS.has(context.hostname)) {
    return '/api';
  }

  // Customer-owned resident domains only serve the public access, resident and
  // form-answering flows.
  // Limiting this override to those routes preserves explicit API configuration
  // on unrelated staging and self-hosted manager deployments.
  const residentPath = /^\/(?:access|resident|f|p|parking)(?:\/|$)/.test(context.pathname ?? '');
  if (context.hostname
    && residentPath
    && context.hostname !== 'localhost'
    && context.hostname !== '127.0.0.1'
    && !context.hostname.endsWith('.vercel.app')) {
    return '/api';
  }

  return configuredApiUrl || '/api';
}
